import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/components/Typography';
import { FleetTypeRadio, type FleetTypeRadioProps } from '@/components/forms/fields/FleetTypeRadio';
import type { V2FleetType } from '@/services/rental-api-client';
export interface FleetTypeRadioGroupProps extends Omit<FleetTypeRadioProps, 'fleetType'> {
  fleetTypes: V2FleetType[];
  label?: string;
}
export function FleetTypeRadioGroup(t0) {
  const $ = _c(14);
  let fleetTypes;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      fleetTypes,
      label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = fleetTypes;
    $[2] = label;
    $[3] = props;
  } else {
    fleetTypes = $[1];
    label = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== label) {
    t1 = <Typography variant="caption" as="div" className="mb-1">{label}</Typography>;
    $[4] = label;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== fleetTypes || $[7] !== props) {
    t2 = fleetTypes?.map(fleetType => <FleetTypeRadio key={fleetType.slug} fleetType={fleetType} data-testid={`fleet-type-radio-${fleetType.slug}`} role="radio" aria-checked={props.value === fleetType.slug} {...props} />);
    $[6] = fleetTypes;
    $[7] = props;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="flex flex-col gap-4" role="radiogroup">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}